// extracted by mini-css-extract-plugin
module.exports = {"TableOfContents":"Legal_TableOfContents__w_MwH","Link":"Legal_Link__2vbbb","Content":"Legal_Content__3drtj","Section":"Legal_Section__3O1VI"};